/* eslint-disable react/prop-types */
import React from 'react'

const TournamentItem = ({ title, description, imgUrl }) => {
	return (
		<div className='w-full lg:w-2/3 md:mx-2 mb-4 md:mb-0'>
			<div className='overflow-hidden rounded-betish bg-main-primary shadow-card'>
				<img
					className='md:h-80 h-32 w-full object-cover object-center rounded-betish mb-2'
					src={imgUrl}
					alt=''
				/>
				<div className='p-4 h-auto md:h-40 lg:h-48'>
					<a href='/' className='text-main-secondary text-xl md:text-2xl mb-4'>
						{title}
					</a>
					<div className='text-sm md:text-md text-justify'>{description}</div>
				</div>
			</div>
		</div>
	)
}

export default TournamentItem
